module.exports = __webpack_public_path__ + "1bf9058dd76c65d3457d7ea8a5b8d453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_3.jpg
// module id = 1706
// module chunks = 5